var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "button",
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.download },
    },
    [_vm._v("JSON export")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }